import { makeStyles } from '@material-ui/styles';
import { alpha } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  link: {
    textDecoration: 'none',
    '&:hover, &:focus': {
      backgroundColor: theme.palette.background.light,
    },
  },
  linkRoot: {
    borderRadius: 10,
    marginBottom: 2,
    paddingTop: 9,
    paddingBottom: 9,
  },
  externalLink: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
  },
  linkActive: {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    '&:hover, &:focus': {
      backgroundColor: alpha(theme.palette.primary.main, 0.18),
    },
  },
  linkNested: {
    paddingLeft: 0,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.background.light,
    },
  },
  linkIcon: {
    marginRight: theme.spacing(1),
    color: `${theme.palette.text.secondary}99`,
    transition: theme.transitions.create('color'),
    width: 24,
    minWidth: 24,
    display: 'flex',
    justifyContent: 'center',
  },
  linkIconActive: {
    color: theme.palette.primary.main,
  },
  linkText: {
    padding: 0,
    color: `${theme.palette.text.secondary}CC`,
    transition: theme.transitions.create(['opacity', 'color']),
    fontSize: 16,
  },
  linkTextActive: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  linkTextHidden: {
    opacity: 0,
  },
  nestedList: {
    paddingLeft: theme.spacing(2) + 20,
  },
  sectionTitle: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    height: 1,
    backgroundColor: theme.palette.divider,
  },
}));
